import { LOCALE_ID } from '@angular/core';
import { GoogleLoginProvider, SocialAuthServiceConfig } from '@abacritt/angularx-social-login';
import { AUTH_CONTEXT_CONFIG, AuthContextConfig } from '@portal-front/portal-auth-shared-util-config';

export const socialAuthServiceConfig = {
  provide: 'SocialAuthServiceConfig',
  useFactory: (localeId: string, contextConfig: AuthContextConfig) => {
    return {
      autoLogin: false,
      lang: localeId,
      providers: [
        {
          id: GoogleLoginProvider.PROVIDER_ID,
          // @TODO: Replace with client ID from environment variables (When EFN-3620 ready)
          provider: new GoogleLoginProvider(contextConfig.googleAuthClientId, {
            scopes: ['openid', 'profile', 'email'],
            oneTapEnabled: contextConfig.oneTapLoginEnabled !== false,
          }),
        },
      ],
    } as SocialAuthServiceConfig;
  },
  deps: [LOCALE_ID, AUTH_CONTEXT_CONFIG],
};
